
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fHNg2", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.d80b271e.js.map
